import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { ScrollView, View } from 'react-native';
import { ScreenLayout } from '@/components/ScreenLayout';
import FavoriteListView from './components/FavoriteListView';
export default function FavoritePlacesScreen() {
    return (_jsxs(ScreenLayout, { isHeaderVisible: true, children: [_jsx(View, { className: "border-b-[1px] border-blue-5" }), _jsx(ScrollView, { className: "bg-white", contentContainerClassName: "grow", children: _jsx(FavoriteListView, {}) })] }));
}
